<template>
  <v-main>
    <div class="home-main-content">
      <CommunicationContainer v-if="tabIndex === 'message'" />
      <RecordsContainer v-if="tabIndex === 'record'" />
      <OthersContainer
        v-if="tabIndex === 'other'"
        :active-diary="activeDiary ?? undefined"
        @update:activeDiary="activeDiary = $event"
      />
      <MemoruTopContainer v-if="tabIndex === 'memoru'" />
      <SettingContainer v-if="tabIndex === 'setting'" />
    </div>

    <v-bottom-navigation app grow v-model="tabIndex" color="primary" mandatory>
      <v-btn v-if="shouldShowMessage" value="message" style="height: auto; min-width: 0;">
        <v-icon>mdi-message-text</v-icon>
        <span>{{ $t('tabBar.communication') }}</span>
      </v-btn>
      <v-btn v-if="shouldShowRecord" value="record" style="height: auto; min-width: 0;">        
        <v-icon>mdi-pencil</v-icon>
        <span>{{ $t('tabBar.record') }}</span>
      </v-btn>
      <v-btn v-if="shouldShowOther" value="other" style="height: auto; min-width: 0;" @click="handleOtherClick">
        <v-icon>mdi-dots-horizontal</v-icon>
        <span>{{ $t('tabBar.other') }}</span>
      </v-btn>
      <!-- MEMORU tab hidden as requested -->
      <v-btn v-if="shouldShowSettings" value="setting" style="height: auto; min-width: 0">
        <v-icon>mdi-cog</v-icon>
        <span>{{ $t('tabBar.settings') }}</span>
      </v-btn>
    </v-bottom-navigation>
  </v-main>
</template>
<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";
import CommunicationContainer from '@/container/communication/CommunicationContainer.vue';
import RecordsContainer from '@/container/records/RecordsContainer.vue';
import OthersContainer from '@/container/others/OthersContainer.vue';
import SettingContainer from '@/container/setting/SettingContainer.vue';
import MemoruTopContainer from '@/container/memoru/MemoruTopContainer.vue';
import LocalDataService from '@/service/LocalDataService';
import { auth0Module } from '@/store/dataModules/auth0Module';
import { meModule } from '@/store/dataModules/meModule';
import { MeNurserySchoolResponse, MeResponse } from 'chaild-api/lib';
import NurserySchoolDiaryContainer from '@/container/others/NurserySchoolDiaryContainer.vue';

const url = process.env.VUE_APP_API_URL;
const instanceId = process.env.VUE_APP_BEAMS_INSTANCE_ID;
const apiKey = process.env.VUE_APP_X_API_KEY;

export default defineComponent({
  components: {
    NurserySchoolDiaryContainer,
    CommunicationContainer,
    RecordsContainer,
    OthersContainer,
    SettingContainer,
    MemoruTopContainer,
  },

  data() {
    return {
      tabIndex: 'message' as number | string,
      activeDiary: null as 'nursery' | 'nursery-hours' | null,
    };
  },

  watch: {
    tabIndex(val) {
      if (!val) return;
      if (val !== 'other') this.activeDiary = null;
    }
  },

  computed: {
    me(): MeResponse | null {
      const me = LocalDataService.getUser();
      return me;
    },
    currentScool(): MeNurserySchoolResponse | undefined {
      if (this.me) {
        let nurserySchool = this.me.nurserySchools.find(nursery => nursery.isDefault === true);
        if (this.me.nurserySchools.length === 0) {
          return undefined
        }
        if (!nurserySchool) {
          nurserySchool = this.me.nurserySchools[0];
        }
        return nurserySchool;
      }
      return undefined;
    },
    shouldShowMessage() {
      if (this.currentScool) {
        const messageFeature = this.currentScool.applicationPlan.nurseryMobile.featureGroups.find((fg) => fg.name === "連絡");
        if (!messageFeature) {
          return false;
        }
        const length = messageFeature.features.filter((f) => f.isEnabled).length;
        if (length > 0) {
          return true;
        }
      }
      return false;
    },
    shouldShowRecord() {
      if (this.currentScool) {
        const messageFeature = this.currentScool.applicationPlan.nurseryMobile.featureGroups.find((fg) => fg.name === "記録");
        if (!messageFeature) {
          return false;
        }
        const length = messageFeature.features.filter((f) => f.isEnabled).length;
        if (length > 0) {
          return true;
        }
      }
      return false;
    },
    shouldShowOther() {
      return true;
      // NOTE: 設定経由で表示の切り替えをユーザーにさせる場合は以下のコードを利用する
      // if (this.currentScool) {
      //   const messageFeature = this.currentScool.applicationPlan.nurseryMobile.featureGroups.find((fg) => fg.name === "その他");
      //   if (!messageFeature) {
      //     return false;
      //   }
      //   const length = messageFeature.features.filter((f) => f.isEnabled).length;
      //   if (length > 0) {
      //     return true;
      //   }
      // }
      // return false;
    },
    shouldShowMemoru() {
      if (this.currentScool) {
        const messageFeature = this.currentScool.applicationPlan.nurseryMobile.featureGroups.find((fg) => fg.name === "MEMORU");
        if (!messageFeature) {
          return false;
        }
        const length = messageFeature.features.filter((f) => f.isEnabled).length;
        if (length > 0) {
          return true;
        }
      }
      return false;
    },
    shouldShowSettings() {
      if (this.currentScool) {
        const messageFeature = this.currentScool.applicationPlan.nurseryMobile.featureGroups.find((fg) => fg.name === "設定");
        if (!messageFeature) {
          return false;
        }
        const length = messageFeature.features.filter((f) => f.isEnabled).length;
        if (length > 0) {
          return true;
        }
      }
      return false;
    },
  },

  methods: {
    handleOtherClick() {
      // すでに OTHER 画面ならリセット
      if (this.tabIndex === 'other') {
        this.activeDiary = null;
      }
      // tabIndex は v-model で自動更新される（変更があれば）
    },
    initBeams: async function() {
      try {
        // rhyme対応
        console.log('start init auth');
        const sessionAndToken = LocalDataService.getPushAuthorizer();
        if ((window as any).webkit && (window as any).webkit.messageHandlers !== undefined) {
          (window as any).webkit.messageHandlers.pusher.postMessage(`${sessionAndToken}`);
        }

        /*  Pusher */
        const accessToken = await auth0Module.getAuth0Token();
        const user = LocalDataService.getUser();
        const PusherPushNotifications = await import('@pusher/push-notifications-web');

        if (instanceId && apiKey && user) {
          let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
          if (!nurserySchool) {
            nurserySchool = user.nurserySchools[0];
          }
          const currentUserId = `${nurserySchool.userId}`;
          const token = await auth0Module.getAuth0Token();
          if (currentUserId && token) {
            LocalDataService.setPushAuthorizer(`${token},${currentUserId}`);
          }
          const beamsTokenProvider = new PusherPushNotifications.TokenProvider({
            url: url + '/push/auth',
            queryParams: {
              user_id: currentUserId,
            },
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'Content-Type': 'application/json; charset=utf-8',
              'x-api-key': apiKey,
            },
          });

          window.navigator.serviceWorker.ready.then(async serviceWorkerRegistration => {
            const beamsClient = new PusherPushNotifications.Client({
              instanceId: instanceId,
              serviceWorkerRegistration,
            });
            beamsClient
              .getUserId()
              .then(userId => {
                if (userId !== currentUserId) {
                  console.log('Unregister for notifications', userId);
                  return beamsClient.stop();
                }
              })
              .catch(console.error);

            // Debug: Check localStorage state
            const permissionAsked = localStorage.getItem('pushNotificationPermissionAsked');
            console.log('🔍 Push notification permission state:', {
              permissionAsked: permissionAsked,
              domain: window.location.origin,
              userId: currentUserId
            });

            // Force show notification for testing (remove this in production)
            if (process.env.NODE_ENV === 'development' || window.location.search.includes('test-notification=true')) {
              localStorage.removeItem('pushNotificationPermissionAsked');
            }

            beamsClient
              .start()
              .then(() => beamsClient.getDeviceId())
              .then(deviceId => {
                console.log('Device ID:', deviceId);
              })
              .then(() => beamsClient.getDeviceInterests())
              .then(async interests => {
                await Promise.all(
                  interests.map(interest => {
                    // 同じ端末で違うアカウントでログインしていた場合、そのsubscribeが残っているため、解除する
                    if (
                      interest !== `NUR-${currentUserId}` &&
                      interest !== `debug-NUR-${currentUserId}`
                    ) {
                      beamsClient.removeDeviceInterest(interest);
                    }
                  })
                );
                if (!interests.includes(`NUR-${currentUserId}`)) {
                  await beamsClient.addDeviceInterest(`NUR-${currentUserId}`);
                }
                if (!interests.includes(`debug-NUR-${currentUserId}`)) {
                  // debug console用のsubscribe
                  // await beamsClient.addDeviceInterest(`debug-NUR-${currentUserId}`);
                }
              })
              .then(() => beamsClient.getDeviceInterests())
              .then(interest => {
                console.log('PUSHER BEAMS Interest:', interest);
              })
              .then(() => beamsClient.setUserId(currentUserId, beamsTokenProvider))
              .then(() => beamsClient.getUserId())
              .then(userId => {
                console.log('PUSHER BEAMS userId:', userId);
              })
              .catch(error => {
                console.log('error', error);
              });
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },

  mounted() {
    this.initBeams();
    meModule.fetchMe();
    console.log(`meModule.tabIndex: ${meModule.tabIndex}`)
    if(meModule.tabIndex) {
      const currentIndex = meModule.tabIndex
      this.tabIndex = currentIndex
      console.log(`currentIndex: ${currentIndex}`)
    }

    const targetTab = sessionStorage.getItem('targetTab');
    if (targetTab) {
      this.tabIndex = targetTab; // タブを切り替え
      sessionStorage.removeItem('targetTab'); // メモを消去（使い捨て）
    }

    
    // 画面を一番上にする
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    // pusherModule.subscribe();
    console.log("HOME.vue")
  },
});
</script>
<style lang="scss" scoped>
.home-main-content {
  /* v-bottom-navigation の高さ分だけ下に余白を持たせて被りを防ぐ */
  padding-bottom: 72px;
}
</style>
